import { render } from "./GolfResults.vue?vue&type=template&id=6816c238&scoped=true"
import script from "./GolfResults.vue?vue&type=script&lang=js"
export * from "./GolfResults.vue?vue&type=script&lang=js"

import "./GolfResults.vue?vue&type=style&index=0&id=6816c238&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/assemble-builder/assemble-sports/broome-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6816c238"]])

export default __exports__